const AddedFromEnum = {
  MICROF: { value: 'M' },
  RHEEM: { value: 'R' },
  OPTIMUS: { value: 'O' },
  POOLS: { value: 'P' },
};

export default AddedFromEnum;
